import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Grid, CircularProgress } from "@mui/material";
import BreadCrumb from "../../../../components/navbar/Breadcrumb";
import { getCategoriaKae, updateCategoriaKae } from "../../../../services";
import { withRouter } from "../../../../providers/withRouter";

const EditarCategoria = () => {
  const { t } = useTranslation('common');
  const { id } = useParams();
  const navigate = useNavigate();
  const [categoria, setCategoria] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategoria();
  }, []);

  const fetchCategoria = async () => {
    try {
      const data = await getCategoriaKae(id);
      setCategoria({
        nombre: data.nombre || "",
        descripcion: data.descripcion || "",
      });
    } catch (error) {
      console.log(error);
      toast.error(t('categories.messages.loadError'));
    } finally {
      setLoading(false);
    }
  };

  function handleSubmit(data) {
    const toastInfo = toast.info(t('categories.messages.saving'));
    let errores = false;

    if (!data.nombre || !data.nombre.trim()) {
      toast.dismiss(toastInfo);
      toast.error(t('categories.messages.fieldRequired', { field: t('categories.columns.name') }));
      errores = true;
    }

    if (!data.descripcion || !data.descripcion.trim()) {
      toast.dismiss(toastInfo);
      toast.error(t('categories.messages.fieldRequired', { field: t('categories.columns.description') }));
      errores = true;
    }

    if (!errores) {
      updateCategoriaKae(id, data)
        .then((res) => {
          if (res.status === 200) {
            toast.update(toastInfo, {
              render: t('categories.messages.updated'),
              type: toast.TYPE.SUCCESS,
              autoClose: true,
            });
            navigate("/categorias");
          } else {
            toast.update(toastInfo, {
              render: t('categories.messages.updateError'),
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          }
        })
        .catch((err) => {
          console.log("ERROR", err);
          toast.error(t('categories.messages.updateError'));
        });
    }
  }

  function handleChange(evt) {
    const value = evt.target.value;
    setCategoria({
      ...categoria,
      [evt.target.name]: value,
    });
  }

  if (loading) {
    return <div style={{ textAlign: "center", padding: 40 }}><CircularProgress style={{ color: "#92004D" }} /></div>;
  }

  return (
    <>
      <BreadCrumb
        rutas={[
          { path: "/categorias", label: t('categories.title') },
          { path: `/categorias/editar/${id}`, label: t('categories.edit') },
        ]}
        style={{ margin: "0 10px" }}
      />
      <div className="pageContent">
        <div className="gridHead">
          {t('categories.editCategory')}
        </div>
        <form className="nuevoAAFFForm">
          <Grid
            container
            spacing={5}
            style={{ marginTop: 20, marginBottom: 20, padding: "0 20px" }}
          >
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                required
                placeholder={t('categories.columns.name')}
                name="nombre"
                value={categoria.nombre}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                required
                placeholder={t('categories.columns.description')}
                name="descripcion"
                value={categoria.descripcion}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <Grid style={{ display: "flex", justifyContent: "end", padding: 20 }}>
            <input
              type="button"
              value={t('actions.save')}
              onClick={() => handleSubmit(categoria)}
            />
          </Grid>
        </form>
      </div>
    </>
  );
};

export default withRouter(EditarCategoria);
